import { z } from 'zod';
import { uuidSchema } from './common.js';
import { kraljicSegmentSchema } from './kraljic.js';
/**
 * Category Strategy persisted (Batch 2 of D-151; Master Spec Strategy subject) — the strategy-on-a-page
 * per category: Kraljic position, statement, objectives/levers/roadmap as editable text, status
 * draft/published. References the Category Register by ID (D-100). Member-write, audited (the
 * category-manager daily loop, D-146 precedent). Shapes shared by the API and the web app.
 */
export const categoryStrategyStatusSchema = z.enum(['draft', 'published']);
export const categoryStrategySchema = z.object({
    id: uuidSchema,
    categoryId: uuidSchema,
    position: kraljicSegmentSchema,
    statement: z.string().nullable(),
    objectivesMd: z.string().nullable(),
    leversMd: z.string().nullable(),
    roadmapMd: z.string().nullable(),
    status: categoryStrategyStatusSchema,
    isDemo: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
/** POST /category-strategies — start a strategy for a category (any member; audited). */
export const createCategoryStrategySchema = z
    .object({
    categoryId: uuidSchema,
    position: kraljicSegmentSchema.optional(),
    statement: z.string().trim().max(2000).optional(),
    objectivesMd: z.string().trim().max(8000).optional(),
    leversMd: z.string().trim().max(8000).optional(),
    roadmapMd: z.string().trim().max(8000).optional(),
})
    .strict();
/** PATCH /category-strategies/:id — edit the page or flip draft/published. */
export const patchCategoryStrategySchema = z
    .object({
    position: kraljicSegmentSchema.optional(),
    statement: z.string().trim().max(2000).nullable().optional(),
    objectivesMd: z.string().trim().max(8000).nullable().optional(),
    leversMd: z.string().trim().max(8000).nullable().optional(),
    roadmapMd: z.string().trim().max(8000).nullable().optional(),
    status: categoryStrategyStatusSchema.optional(),
})
    .strict();
//# sourceMappingURL=categoryStrategies.js.map